import { render, staticRenderFns } from "./CommunicationFolioModal.vue?vue&type=template&id=1f6fcbc2&scoped=true"
import script from "./CommunicationFolioModal.vue?vue&type=script&lang=js"
export * from "./CommunicationFolioModal.vue?vue&type=script&lang=js"
import style0 from "./CommunicationFolioModal.vue?vue&type=style&index=0&id=1f6fcbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6fcbc2",
  null
  
)

export default component.exports